module.exports = __webpack_public_path__ + "static/L2_visual_5_2_eg-e19b6467a9b823e6da9d382d92601b69.png";